import { constants } from "../../../constants";

export default class GameLoadStart {
    constructor(gb) {
        Object.assign(this, { gb });
    }

    DGC_init_handler(data) {
        this.gb.dgcOrigin = data && data.data && data.data.data && data.data.data.origin ? data.data.data.origin : "*"
        const obj = {
            method: 'operator.ready',
            ...(data.target && {
                data: {
                    origin: data.target
                }
            }),
        }

        this.gb.emitters.emit.game.customMsg(obj, this.gb.dgcOrigin)
    }

    DGC_handler(data) {
        this.gb.emitters.emit.web.gameLoadStart();
    }

    QS_handler(data) {
        let obj = {rgMessage: "oprg_Ready"}
        this.gb.emitters.emit.game.customMsg(obj,"*");
    }

    SYN_handler(payload) {
        if (payload.data && payload.data.progress && payload.data.progress > 1 && payload.data.progress < 100 && !this.gb.SynotSentOnceLoadStartEvent) {
            this.gb.emitters.emit.web.gameLoadStart();
            this.gb.SynotSentOnceLoadStartEvent = true
        }
    }

    PT_handler() {
        this.gb.emitters.emit.game.customMsg(JSON.stringify({
            "_type": "ucip.basic.w2gInitializationResponse",
            features: ["sound","openpage","loadingstatus","pause","errors","closegame","gameinstance","gameround","balanceupdate", "betupdate"]
        }))
    }

    _default() {
        this.gb.emitters.emit.web.gameLoadStart();
    }

    exposeEvent() {
        let event = {};

        switch (this.gb.gameProviderProtocol) {
            case constants.GREENTUBE:
                event["Loading"] = this._default;
                break;
            case constants.PRAGMATIC_PLAY:
                event["gameLoadingStarted"] = this._default;
                event["loaded"] = this._default;
            case constants.THUNDER:
                event["gameloading"] = this._default;
                break;
            case constants.AMATIC:
                event["gameStarted"] = this._default;
                break;
            case constants.EGT:
                event["com.egt-bg.launchGame"] = this._default;
                break;
            case constants.EDICT:
                event["gameLoadingStarted"] = this._default;
                break;
            case constants.EZUGI:
                event["loading"] = this._default;
                break;
            // case constants.GSBINGO:
            //     event["gameStarted"] = this._default;
            //     break;
            case constants.GSPOKER:
                event["gameStarted"] = this._default;
                break;
            case constants.DGC:
                event["gel.initialise"] = this.DGC_init_handler;
                event["gel.loading"] = this.DGC_handler;
                break;
            case constants.QS:
            case constants.RELAX:
                event["gprg_Listening"] = this.QS_handler;
                break;
            case constants.WD:
                event["WGEAPI.status.initializing"] = this._default;
                break;
            case constants.STAKELOGIC2:
                event["LOAD_START"] = this._default;
                break;
            case constants.SPRIBE:
                event['ifc.init'] = this._default;
                break;
            case constants.HKS:
                event['onIntegrateReady'] = this._default;
                break;
            case constants.SYN:
                event["g2p.loadProgress"] = this.SYN_handler;
                break;
            case constants.ISOFT:
                event["LOADING_STARTED"] = this._default;
                break;
            case constants.PT:
                event["ucip.basic.g2wInitializationRequest"] = this.PT_handler;
                event["ucip.loadingstatus.g2wLoadingStartNotification"] = this._default;
                break;
            case constants.HBN:
                // event["frameReady"] = this._default;
                event["gameLoadingStarted"] = this._default;
                break;
            case constants.SPIN:
                event["loading_start"] = this._default;
                break;
            case constants.PLS:
                event["load"] = this._default;
                break;
            case constants.SPINOMENAL:
                event["gameLoadingStart"] = this._default;
                break;
            case constants.ENDOR:
                event["gameLoadStarted"] = this._default;
                break;
            case constants.EDIG:
                event["gameLoadStarted"] = this._default;
                break;
            case constants.T4B:
                event["game.loaded"] = this._default;
                break;
            case constants.EYE:
                event["gameInitialize"] = this._default;
                break;
            case constants.HNR:
                event["gameLoadingStarted"] = this._default;
                break;
            case constants.OAK:
                event["game_start"] = this._default;
                break;
            case constants.YGG:
                event["splashScreen/ready"] = this._default;
                break;
            case constants.BSFT:
                event["exi_onGameDataLoaded"] = this._default;
                break;
            case constants.EVOLUTION:
                event["APPLICATION_LOAD_STARTED"] = this._default;
                break;
            // case constants.NLC:
            //     event["intro"] = this._default;
            //     break;
            default:
                event["loadStart"] = this._default;
                event["loadProcessStart"] = this._default;
        }

        return event;
    }
}
